import React, { useEffect, useRef, } from "react"

import {
	Route,
	Routes,
	useLocation,
} from "react-router-dom"

import { Layout } from "structure"

import {
	PageForbidden,
	PageNotFound,
	PageWip,
} from "pages/errors"

import {
	Actions,
	Affiliates,
	AssetDetails,
	AssetList,
	BrandManagement,
	BrandProfile,
	Contract,
	Documents,
	EconomicManagement,
	Favourites,
	Home,
	MatchDetails,
	MatchProposal,
	MatchProposalCreation,
	MatchProposalDetails,
	Messages,
	Notifications,
	Microjob,
	MicrojobDetails,
	Proposals,
	Research,
	SupportAndDocumentation,
	User,
	UserDetails,
	Workflow,
	VisitCalendar,
} from "./pages"
import { SessionResponse } from "./models";
import MicrojobJobs from "pages/microjob-jobs/microjob-jobs"

// interface RequireRolesProps
// {
// 	keycloak: any,
// 	roles: string[],
// }
// export class RequireRoles extends React.Component<RequireRolesProps, {}>
// {
// 	private isLoggedIn = (): boolean => {
// 		return false
// 	}
//
// 	private hasRoles = (): boolean => {
// 		return false
// 	}
//
// 	public render()
// 	{
// 		if(!this.isLoggedIn()) {
// 			return <Navigate to="/login-required" replace />
// 		}
// 		if(!this.hasRoles()) {
// 			return <Navigate to="/forbidden" replace />
// 		}
//
// 		return this.props.children
// 	}
// }

function ScrollToTop() {
	const { pathname } = useLocation()
	const oldPage = useRef(pathname)

	useEffect(() => {
		if (pathname === oldPage.current) {
			return
		}

		oldPage.current = pathname
		const main: any = document.getElementsByTagName("main")
		if (main === null || !(main instanceof HTMLCollection) || main.length === 0) {
			return
		}

		main[0].scrollTo({ top: 0, left: 0, behavior: "smooth" })
	}, [pathname])

	return null
}

const routes = ({ sessionData }: { sessionData: SessionResponse }) => {
	const isBrand: boolean = sessionData.accountType === "BRAND"

	console.log(sessionData)

	return (
		<>
			<ScrollToTop />
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route index element={<Home sessionData={sessionData} />} />
					<Route path="match-proposal" element={<Layout />}>
						<Route index element={<MatchProposal />} />
						<Route path="asset/:assetId" element={<MatchProposalCreation />} />
						<Route path="match/:matchId" element={<MatchProposalDetails />} />
					</Route>
					<Route path="forbidden" element={<PageForbidden />} />
					<Route path="wip" element={<PageWip />} />
					<Route path="*" element={<PageNotFound />} />
				</Route>
				{
					!isBrand ?
						<Route path="/brand" element={<Layout />}>
							<Route index element={<BrandManagement />} />
							<Route path=":brandId" element={<BrandProfile sessionData={sessionData} />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				{
					
						<Route path="/asset" element={<Layout />}>
							<Route index element={<AssetList sessionData={sessionData} />} />
							<Route path=":assetId" element={<AssetDetails sessionData={sessionData} />} />
						</Route>
				}

				<Route path="/match" element={<Layout />}>
					<Route path=":matchId" element={<MatchDetails sessionData={sessionData} />} />
				</Route>
				<Route path="/visit" element={<Layout />}>
					<Route index element={<VisitCalendar />} />
				</Route>
				<Route path="/actions" element={<Layout />}>
					<Route index element={<Actions sessionData={sessionData} />} />
				</Route>
				<Route path="/notifications" element={<Layout />}>
					<Route index element={<Notifications sessionData={sessionData} />} />
				</Route>
				<Route path="/messages" element={<Layout />}>
					<Route index element={<Messages sessionData={sessionData} />} />
				</Route>
				{
					!isBrand ?
						<Route path="/workflow" element={<Layout />}>
							<Route index element={<Workflow />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				{
					!isBrand ?
						<>
							<Route path="/microjob" element={<Layout />}>
								<Route index element={<Microjob />} />
								<Route path=":microjobId" element={<MicrojobDetails />} />
							</Route>
							<Route path="/jobs" element={<Layout />}>
								<Route index element={<MicrojobJobs />} />
							</Route>
						</>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				{
					!isBrand ?
						<Route path="/contract" element={<Layout />}>
							<Route index element={<Contract />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				{
					!isBrand ?
						<Route path="/user" element={<Layout />}>
							<Route index element={<User />} />
							<Route path=":userId" element={<UserDetails />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				{
					!isBrand ?
						<Route path="/economic" element={<Layout />}>
							<Route index element={<EconomicManagement />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				<Route path="/supporto" element={<Layout />}>
					<Route index element={<SupportAndDocumentation />} />
				</Route>
				{
					!isBrand ?
						<Route path="/documents" element={<Layout />}>
							<Route index element={<Documents sessionData={sessionData} />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				{
					isBrand ?
						<Route path="/proposals" element={<Layout />}>
							<Route index element={<Proposals />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				{
					isBrand ?
						<Route path="/favourites" element={<Layout />}>
							<Route index element={<Favourites />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				{
					isBrand ?
						<Route path="/affiliates" element={<Layout />}>
							<Route index element={<Affiliates />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
				{
					isBrand ?
						<Route path="/research" element={<Layout />}>
							<Route index element={<Research sessionData={sessionData} />} />
						</Route>
						:
						<Route path="/" element={<Layout />}>
							<Route path="*" element={<PageNotFound />} />
						</Route>
				}
			</Routes>
		</>
	)
}

export default routes
